<template lang="pug">
Suspense
  ProductPage.custom-bar(:product="product" :showTabsSlot="true" :showMainSlot="true")
    template(#title="slotProps")
      ProductTitle(:product="product" :show-h1="slotProps.showH1")
    template(#tabs)
      RenderBlock(:block="slots.tabs" :product="product")
    template(#media)
      custom-bumper-render-fonts
      Media(
        :gallery="gallery"
        layout="desktop"
        v-model="selectedImg"
        :product="product"
      )
        template(#overlay="data")
          client-only
            .img-overlay
              collar-text( v-if="data.idx === 1" :options="options" :angle="1" :sku="sku")
              collar-text( v-if="data.idx === 2" :options="options" :angle="2" :sku="sku")
              .shaft-text(v-if="data.idx === 3 && tab === 'Add Shaft Text'")
                shaft-multi-text(
                  v-if="sku === 'CUSTOMOHIOPOWER_NEW'"
                  :options="options"
                )
                shaft-text(
                  v-else
                  :options="options"
                )
              .shaft-image(v-if="data.idx === 3 && tab.indexOf('Shaft Image') > -1")
                shaft-multi-image(
                  v-if="sku === 'CUSTOMOHIOPOWER_NEW'"
                  :options="options"
                )
                shaft-image(
                  v-else
                  :options="options"
                )
              collar-text( v-if="data.idx === 4" :options="options" :sku="sku")
      .canvas(v-if="debug" ref="canvas")
    template(#rhpa)
      product-badges.rhpa-badges( :product="product" )
      loading(v-if="buyRequest.loading")
      rhpa(:buy-request="buyRequest" @change="$emit('change')" :class="classes"  v-else)
        template(#rhpaBody)
          Message.error(status="error" v-if="!!error")
            Icon.left-icon(name="alert-error")
            | {{ __(error) }}
          img.zeus-tool-logo(src='@/assets/zeus-custom.svg' alt="Zeus Tool" height="50" width="150")
          Accordion(:heading="__('Shaft')" :secondary="__(simple.attributes.color)" theme="rhpa" :modelValue="selectedAttr === 'bar'" @update:modelValue="selectedAttr = $event ? 'bar' : null" left-icon="zeus/shaft" open-icon="arrow-up" closed-icon="arrow-down")
            configuration(:buyRequest="buyRequest")
          Accordion(:heading="__('Sleeve')" :secondary="__(options.sleeve.val)" theme="rhpa" :modelValue="selectedAttr === 'sleeve'" @update:modelValue="selectedAttr = $event ? 'sleeve' : null" left-icon="zeus/sleeve" open-icon="arrow-up" closed-icon="arrow-down")
            Swatches(label="Choose Sleeve Finish" :options="options.sleeve.swatches" v-model="options.sleeve.val" @update:modelValue="showImage([1,2,4])")
          Accordion(:heading="__('Bushing')" :secondary="__(options.bushing.val)" theme="rhpa" :modelValue="selectedAttr === 'bushing'" @update:modelValue="selectedAttr = $event ? 'bushing' : null" left-icon="zeus/bushing" open-icon="arrow-up" closed-icon="arrow-down")
            Swatches(label="Choose Bushing Finish" :options="options.bushing.swatches" v-model="options.bushing.val"  @update:modelValue="showImage([1,4])")
          Accordion(:heading="__('Customize Shaft')" theme="rhpa"  :modelValue="selectedAttr === 'customShaft'" @update:modelValue="selectedAttr = $event ? 'customShaft' : null" left-icon="zeus/add-image" open-icon="arrow-up" closed-icon="arrow-down")
            Tabs(:tabs="tabs" :modelValue="tab" @update:modelValue="tab = $event")
            .text-customization(v-if="tab === 'Add Shaft Text' || tab === 'Shaft Text'")
              .multi-text(v-if="sku === 'CUSTOMOHIOPOWER_NEW'")
                RogueInput(label="Left Shaft Text" :modelValue="options.shaftTextLeft.val" @update:modelValue="updateText($event, options.shaftTextLeft, [3])" :maxlength="13")
                RogueInput(label="Right Shaft Text" :modelValue="options.shaftTextRight.val" @update:modelValue="updateText($event, options.shaftTextRight, [3])" :maxlength="13")
                Swatches.font-choice.segment( :options="fontOpts" v-model="options.shaftFont.val" @update:modelValue="selectedImg = 3" label='Font')
              .single-text(v-else)
                RogueInput(label="Shaft Text" :modelValue="options.shaftText.val" @update:modelValue="updateText($event, options.shaftText, [3])" :maxlength="24")
                Swatches(label="Font" :options="fontOpts" v-model="options.shaftFont.val"  @update:modelValue="selectedImg = 3")
            custom-file-upload(v-if="tab === 'Add Shaft Image'" :select-image="selectImage" product-type="bar" :multi-color="multiColor")
              template(#top)
                p {{__('Barbell Shaft is always two sided. Side one of the barbell shaft will always contain the Rogue logo and can not be customized. Side two of the barbell shaft can contain a custom image or custom text.')}}
              template(#bottom)
                p {{__('All custom sales are final and cannot be returned. In addition to your transit time, please allow 7-14 business days to assemble your {barName}', {barName: product.name})}}
            custom-file-upload(v-if="tab === 'Add Left Shaft Image'" :select-image="selectLeftImage" product-type="bar")
              template(#top)
                p {{__('Barbell Shaft is always two sided. Side one of the barbell shaft will always contain the Rogue logo and can not be customized. Side two of the barbell shaft can contain a custom image or custom text.')}}
              template(#bottom)
                p {{__('All custom sales are final and cannot be returned. In addition to your transit time, please allow 7-14 business days to assemble your {barName}', {barName: product.name})}}
            custom-file-upload(v-if="tab === 'Add Right Shaft Image'" :select-image="selectRightImage" product-type="bar")
              template(#top)
                p {{__('Barbell Shaft is always two sided. Side one of the barbell shaft will always contain the Rogue logo and can not be customized. Side two of the barbell shaft can contain a custom image or custom text.')}}
              template(#bottom)
                p {{__('All custom sales are final and cannot be returned. In addition to your transit time, please allow 7-14 business days to assemble your {barName}', {barName: product.name})}}
            Swatches(label="Color" :options="availableShaftCustomizationColor" v-model="options.shaftColor.val" @update:modelValue="selectedImg = 3" :colors="swatchColors")
          Accordion(:heading="__('Customize Collars')" theme="rhpa"  :modelValue="selectedAttr === 'customCollar'" @update:modelValue="selectedAttr = $event ? 'customCollar' : null" v-if="!disableCollarCustomization" left-icon="zeus/add-text" open-icon="arrow-up" closed-icon="arrow-down")
            RogueInput(label="Collar Text - Top" :modelValue="options.collarTextTop.val" @update:modelValue="updateText($event, options.collarTextTop, [4,1])" :maxlength="11")
            RogueInput(label="Collar Text - Bottom" :modelValue="options.collarTextBottom.val" @update:modelValue="updateText($event, options.collarTextBottom, [4,1])" :maxlength="11")
            Swatches.font-choice(
              :options="fontOpts"
              v-model="options.collarFont.val"
              @update:modelValue="showImage([4,1])"
              label='Font')
            Swatches(label="Color" :options="availableCollarTextColors" v-model="options.collarColor.val" @update:modelValue="showImage([4,1])" :colors="swatchColors")
        template(#rhpaFooter)
          .terms
            b {{__('TERMS')}}:&nbsp;
            span {{__('All custom sales are final and cannot be returned. In addition to your transit time, please allow 3-5 days to assemble your Ohio Bar.') }}
          rhpa-footer.buy-btn(:buy-request="buyRequest" :validate="createRecipe" :disabled="false")
    template(#flexible)
      RenderBlock(:block="slots.flexible" :product="product")
    template(#main)
      RenderBlock(:block="slots.main" :product="product")
    template(#full)
      RenderBlock(:block="slots.full" :product="product")
    template(#bottom)
      ProductBottom(:product="product")
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, onServerPrefetch, onUnmounted, reactive, ref, useTemplateRef, watch, defineAsyncComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { IProductCustomOption } from '@rogue/universal'
import { getStencil } from '@zeus'
import FONTS from '../custom/custom-fonts'
import CustomBumperRenderFonts from '../custom/custom-bumper-render-fonts.vue'
import ShaftText from './shaft-text.vue'
import CollarText from './collar-text.vue'
import { ZeusBarSwatchColorMap, nflRecipeMap } from './util'
import { useProductStore } from '@/js/stores/productStore'
import ShaftImage from '@/js/pages/product/custom-bar/shaft-image.vue'
import ShaftMultiImage from '@/js/pages/product/custom-bar/shaft-multi-image.vue'
import ShaftMultiText from '@/js/pages/product/custom-bar/shaft-multi-text.vue'
import CustomFileUpload from '@/js/pages/product/custom-bar/custom-file-upload.vue'
import { renderToCanvas } from '@/js/pages/product/custom/utils'
import { validateBadWords } from '@/js/helpers/validations/validators'
import { getBuyRequestMeta } from '@/js/helpers/buy-request'
import { computePriceSync } from '@/js/helpers/price-utils'
import { useRogue } from '@/js/services/Rogue'
import type { BuyRequest, BuyRequestMeta, Product } from '@/js/services/RogueTypes'

const ProductTitle = defineAsyncComponent(() => import('../../../components/rhpa/product-title.vue'))
const RhpaFooter = defineAsyncComponent(() => import('../../../components/rhpa/rhpa-footer.vue'))
const Rhpa = defineAsyncComponent(() => import('../../../components/rhpa/rhpa.vue'))
const ProductBadges = defineAsyncComponent(() => import('../../../components/rhpa/badges.vue'))
const ProductBottom = defineAsyncComponent(() => import('@/js/pages/product/product-bottom.vue'))

const BUSHING_MAP: Record<string, string> = {
  Bronze : 'BRN',
  Red    : 'RED',
  Black  : 'BLK',
}

// Characters the engraver can't reproduce. Matched by Unicode property rather than by
// hardcoded surrogate ranges so new emoji blocks are covered without another code change:
// pictographs and skin-tone modifiers, the whole U+1F000-1FBFF symbol plane, the joiners
// and selectors that would otherwise be left orphaned (ZWJ, keycap, variation, flag tags),
// plus the U+2011-27BF and private-use sweeps the original filter already applied.
const UNSUPPORTED_TEXT = /\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Variation_Selector}|[\u{1F000}-\u{1FBFF}]|[\u{E0020}-\u{E007F}]|[\u{E000}-\u{F8FF}]|[\u{2011}-\u{27BF}]|\u{200D}|\u{20E3}/gu

type BarOptionType = 'color' | 'font' | 'text' | 'file'

interface BarOption {
  id: number | null
  val: string | null
  type: BarOptionType
  options?: Record<string, number>
  swatches?: { label: string, value: string, imgAttr: string }[]
}

type BarOptionKey = 'bushing' | 'sleeve' | 'shaftColor' | 'shaftFont' | 'collarColor' | 'collarFont'
  | 'shaftText' | 'shaftTextLeft' | 'shaftTextRight'
  | 'shaftImage' | 'shaftImageOriginal'
  | 'shaftImageLeft' | 'shaftImageLeftOriginal'
  | 'shaftImageRight' | 'shaftImageRightOriginal'
  | 'collarTextTop' | 'collarTextBottom'

interface RecipeResponse {
  recipeId: string
  productId: number
  sku: string
  customizations: { key: BarOptionKey, value: string | null }[]
}

// The @zeus renderers only read `{ val }` off each option; ours carry extra editor state
type ZeusBarOptions = Parameters<typeof getStencil>[1]

const props = withDefaults(defineProps<{
  buyRequest: BuyRequest,
  sku: string,
  debug?: boolean,
}>(), { debug: false })

const emit = defineEmits<{ change: [] }>()

const rogue = useRogue()
const route = useRoute()
const router = useRouter()
const productStore = useProductStore()

const canvasRef = useTemplateRef<HTMLDivElement>('canvas')

const selectedImg = ref(0)
const selectedAttr = ref<string | null>('bar')
const tab = ref('Add Shaft Text')
const disableCollarCustomization = ref(false)
const error = ref<string | null>(null)
const gallery = ref<NonNullable<Product['gallery']>>([])

const swatchColors = ZeusBarSwatchColorMap
const fontOpts = [
  { label: 'Arvo', svg: FONTS.ARVO, value: 'arvo' },
  { label: 'Arimo', svg: FONTS.ARIMO, value: 'arimo' },
  { label: 'Montserrat', svg: FONTS.MONTSERRAT, value: 'montserrat' },
]

const options = reactive<Record<BarOptionKey, BarOption>>({
  bushing                 : { id: null, swatches: [], val: '', type: 'color' },
  sleeve                  : { id: null, swatches: [], val: '', type: 'color' },
  shaftColor              : { id: null, swatches: [], val: '', type: 'color' },
  shaftFont               : { id: null, swatches: [], val: '', type: 'font' },
  collarColor             : { id: null, swatches: [], val: '', type: 'color' },
  collarFont              : { id: null, swatches: [], val: '', type: 'font' },
  shaftText               : { id: null, val: '', type: 'text' },
  shaftTextLeft           : { id: null, val: '', type: 'text' },
  shaftTextRight          : { id: null, val: '', type: 'text' },
  shaftImage              : { id: null, val: '', type: 'file' },
  shaftImageOriginal      : { id: null, val: '', type: 'file' },
  shaftImageLeft          : { id: null, val: '', type: 'file' },
  shaftImageLeftOriginal  : { id: null, val: '', type: 'file' },
  shaftImageRight         : { id: null, val: '', type: 'file' },
  shaftImageRightOriginal : { id: null, val: '', type: 'file' },
  collarTextTop           : { id: null, val: '', type: 'text' },
  collarTextBottom        : { id: null, val: '', type: 'text' },
})

const products = computed(() => productStore.products)

const multiColor = computed(() => window.ROGUE.env !== 'prod' && Boolean(route.query.multicolor))

const tabs = computed(() => {
  if (props.sku === 'CUSTOMOHIOPOWER_NEW') {
    return ['Add Shaft Text', 'Add Left Shaft Image', 'Add Right Shaft Image']
  }

  return ['Add Shaft Text', 'Add Shaft Image']
})

const simple = computed<Product>(() => (props.buyRequest.children && products.value[props.buyRequest.children[0]?.productId])
  || ({ attributes: {} } as unknown as Product))

const product = computed(() => products.value[props.buyRequest.productId])

const slots = computed(() => ((product.value.roguebuilder || {}).slots || {}))

const availableShaftCustomizationColor = computed(() => options.shaftColor.swatches!.filter(s => s.label !== simple.value.attributes.color))

const availableCollarTextColors = computed(() => options.collarColor.swatches!.filter(s => s.label !== options.sleeve.val))

const classes = computed(() => [
  `shaft-${simple.value.attributes.color?.replace(/ /g, '_').toLowerCase() || 'none'}`,
  `sleeve-${(options.sleeve.val || '').replace(/ /g, '_').toLowerCase() || 'none'}`,
])

function trimmed(option: BarOption) {
  return (option.val || '').trim()
}

function showImage(validImages: number[]) {
  if (!validImages.includes(selectedImg.value)) {
    selectedImg.value = validImages[0]
  }
}

function updateText(value: string, property: BarOption, imageToSelect: number[]) {
  property.val = value.replace(UNSUPPORTED_TEXT, '')
  showImage(imageToSelect)
}

function updateGallery() {
  gallery.value = product.value.gallery!.map((image, i) => {
    if (i === 0 || i === 3) {
      return image
    }

    return { ...image, link: `${image.link.split('-DYN.png')[0]}-${BUSHING_MAP[options.bushing.val!]}-DYN.png` }
  })
}

function validateColors() {
  try {
    if (!availableCollarTextColors.value.some(color => color.value === options.collarColor.val)) {
      options.collarColor.val = availableCollarTextColors.value[0].value
    }

    if (!availableShaftCustomizationColor.value.some(color => color.value === options.shaftColor.val)) {
      options.shaftColor.val = availableShaftCustomizationColor.value[0].value
    }
    if (options.sleeve.val === 'Chrome') {
      disableCollarCustomization.value = true
      if (options.collarTextTop.val !== '' || options.collarTextBottom.val !== '') {
        options.collarTextTop.val = ''
        options.collarTextBottom.val = ''
      }
    } else {
      disableCollarCustomization.value = false
    }
  } catch {
    //
  }
}

function update() {
  validateColors()

  const opts: Record<string, unknown> = {}

  Object.values(options)
    .filter(option => option.id && option.type !== 'file')
    .forEach(option => opts[option.id!] = option.swatches ? option.options![option.val!] : option.val)

  // If they did not add shaft text, we need to set the Color option to None
  if (tab.value.indexOf('Text') !== -1) {
    let hasShaftText = trimmed(options.shaftText).length > 0
    if (props.sku === 'CUSTOMOHIOPOWER_NEW') {
      hasShaftText = (trimmed(options.shaftTextLeft).length + trimmed(options.shaftTextRight).length) > 0
    }
    if (!hasShaftText) {
      opts[options.shaftColor.id!] = options.shaftColor.options!.None
    }
  } else if (tab.value.indexOf('Image') !== -1) {
    let hasShaftImage = Boolean(options.shaftImage.val)
    if (props.sku === 'CUSTOMOHIOPOWER_NEW') {
      hasShaftImage = Boolean(options.shaftImageLeft.val || options.shaftImageRight.val)
    }
    if (!hasShaftImage) {
      opts[options.shaftColor.id!] = options.shaftColor.options!.None
    }
  }

  // If they did not add collar text, we need to set the Color option to None to remove the price increase
  const hasCollarText = (`${options.collarTextBottom.val}${options.collarTextTop.val}`).trim().length > 0
  if (!hasCollarText) {
    opts[options.collarColor.id!] = options.collarColor.options!.None
  }

  Object.assign(props.buyRequest.options!, opts)

  emit('change')
  updateGallery()
}

let onScroll: (() => void) | null = null

function handleScroll() {
  let media = document.getElementById('pdp-media')

  // #pdp-media comes from ProductPage inside a Suspense boundary, so it can still
  // be absent when a scroll event fires - re-query and bail until it exists.
  onScroll = () => {
    if (!media) {
      media = document.getElementById('pdp-media')
      if (!media) return
    }
    const rect = media.getBoundingClientRect()
    if (rect.top <= 0) {
      if (!media.classList.contains('sticky')) {
        media.classList.add('sticky')
      }
    } else {
      media.classList.remove('sticky')
    }
  }

  window.document.addEventListener('scroll', onScroll)
}

function loadOptions() {
  const opts: IProductCustomOption[] = product.value.customOptions || []

  const loadOpt = (optTitle: string, type: BarOptionType, imgAttr = 'color'): BarOption => {
    const data = opts.find(opt => opt.title === optTitle)

    if (!data) {
      rogue.log.debug(`No type ${optTitle} for ${product.value.sku}`)

      return reactive({
        id  : null,
        val : '',
        type,
      })
    }

    if ((data.type as string) === 'field') {
      return reactive({
        id  : data.id,
        val : props.buyRequest.options![data.id] || '',
        type,
      })
    }

    let value
    if (optTitle.indexOf('Color') > -1) {
      value = data.values!.filter(opt => opt.title !== 'None' && opt.title !== simple.value.attributes.color)[0]?.title
    } else {
      value = data.values!.find(v => v.id === props.buyRequest.options?.[data.id])?.title || data.values![0]?.title || ''
    }

    return reactive({
      id       : data.id,
      options  : data.values!.reduce((prev, val) => Object.assign(prev, { [val.title]: val.id }), {} as Record<string, number>),
      swatches : data.values!.map(v => ({ label: v.title, value: v.title, imgAttr })).filter(opt => opt.label !== 'None'),
      val      : value,
      type,
    })
  }

  options.bushing = loadOpt('Choose Bushing Finish', options.bushing.type)
  options.sleeve = loadOpt('Choose Sleeve Finish', options.sleeve.type)
  options.shaftColor = loadOpt('Custom Text Color - Shaft', options.shaftColor.type)
  options.shaftFont = loadOpt('Custom Font - Shaft', options.shaftFont.type, '')
  options.collarColor = loadOpt('Custom Text Color - Collar', options.collarColor.type)
  options.collarFont = loadOpt('Custom Font - Collar', options.collarFont.type, '')

  if (props.sku === 'CUSTOMOHIOPOWER_NEW') {
    options.shaftTextLeft = loadOpt('Add Left Shaft Text', options.shaftTextLeft.type)
    options.shaftImageLeft = loadOpt('Add Left Shaft Image', options.shaftImageLeft.type)
    options.shaftTextRight = loadOpt('Add Right Shaft Text', options.shaftTextRight.type)
    options.shaftImageRight = loadOpt('Add Right Shaft Image', options.shaftImageRight.type)
  } else {
    options.shaftText = loadOpt('Add Shaft Text', options.shaftText.type)
    options.shaftImage = loadOpt('Add Shaft Image', options.shaftImage.type)
  }

  options.collarTextTop = loadOpt('Add Top Collar Text', options.collarTextTop.type)
  options.collarTextBottom = loadOpt('Add Bottom Collar Text', options.collarTextBottom.type)
}

async function loadProducts() {
  await productStore.loadAllChildren(props.buyRequest.productId, rogue)
  loadOptions()
}

async function validate() {
  error.value = null
  const words = [
    options.collarTextBottom.val,
    options.collarTextTop.val,
    options.shaftText.val,
    options.shaftTextRight.val,
    options.shaftTextLeft.val].join(' ')

  const badWordsError = (await validateBadWords(words)) ? 'Customization cannot contain bad or copy written language' : null
  error.value = badWordsError

  return badWordsError
}

async function createCanvas(svgElem: Element | string, imageLink: string) {
  let stencilHTML = ''
  if (svgElem) {
    const svgElemClone = (svgElem as Element).cloneNode(true) as Element
    svgElemClone.setAttribute('height', '420')
    svgElemClone.setAttribute('width', '746')
    stencilHTML = svgElemClone.outerHTML
  }

  return renderToCanvas(
    stencilHTML,
    `/svc_ssr/cloudinary_proxy/${encodeURIComponent(imageLink.replace(/\//, ''))}`,
    { width: 746, height: 420 },
    { width: 746, height: 420, x: 0, y: 0 }
  )
}

async function createRecipe() {
  try {
    if (await validate()) {
      return false
    }

    options.shaftText.val = trimmed(options.shaftText)
    options.shaftTextLeft.val = trimmed(options.shaftTextLeft)
    options.shaftTextRight.val = trimmed(options.shaftTextRight)
    options.collarTextTop.val = trimmed(options.collarTextTop)
    options.collarTextBottom.val = trimmed(options.collarTextBottom)

    if (tab.value.indexOf('Text') !== -1) {
      if (options.shaftImage.val || options.shaftImageLeft.val || options.shaftImageRight.val) {
        options.shaftImage.val = ''
        options.shaftImageLeft.val = ''
        options.shaftImageRight.val = ''
        update()
      }
    } else if (options.shaftText.val || options.shaftTextLeft.val || options.shaftTextRight.val) {
      options.shaftText.val = ''
      options.shaftTextLeft.val = ''
      options.shaftTextRight.val = ''
      update()
    }

    const meta = getBuyRequestMeta(props.buyRequest, rogue) as BuyRequestMeta & { nonFluidCustomization?: boolean }
    const zeusOptions = options as unknown as ZeusBarOptions
    const renders: { key: string, path: string }[] = []
    const stencils: { key: string, path: string }[] = []
    const uploads: { key: string, path: string }[] = []

    if (options.shaftText.val) {
      const shaftTextHtml = document.getElementsByClassName('shaft-text')[0].getElementsByTagName('svg')[0]
      const canvas = await createCanvas(shaftTextHtml, gallery.value[3].link)
      const stencil = await getStencil(props.sku, zeusOptions, rogue.fetch.bind(rogue), document)
      renders.push({
        key  : 'custom-bar-shaft-text-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
      stencils.push({
        key  : 'custom-bar-shaft-text-stencil',
        path : stencil!.outerHTML,
      })
      if (props.debug) {
        canvasRef.value?.appendChild(stencil!)
      }
    } else if (options.shaftImage.val) {
      const shaftImageEl = document.getElementsByClassName('shaft-image')[0].getElementsByTagName('svg')[0]
      const canvas = await createCanvas(shaftImageEl, gallery.value[3].link)
      const stencil = await getStencil(props.sku, zeusOptions, rogue.fetch.bind(rogue), document)
      renders.push({
        key  : 'custom-bar-shaft-image-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
      stencils.push({
        key  : 'custom-bar-shaft-image-stencil',
        path : stencil!.outerHTML,
      })
      uploads.push({
        key  : 'custom-bar-shaft-image',
        path : options.shaftImageOriginal.val!,
      })
      if (props.debug) {
        canvasRef.value?.appendChild(stencil!)
      }
    }

    if (!options.shaftImage.val
      && !options.shaftText.val
      && !options.shaftTextRight.val
      && !options.shaftTextLeft.val
      && !options.shaftImageLeft.val
      && !options.shaftImageRight.val
    ) {
      options.shaftColor.val = null
    }

    if (options.shaftTextRight.val || options.shaftTextLeft.val) {
      const shaftTextHtml = document.getElementsByClassName('shaft-multi-text')[0].getElementsByTagName('svg')[0]
      const canvas = await createCanvas(shaftTextHtml, gallery.value[3].link)
      const stencil = await getStencil(props.sku, zeusOptions, rogue.fetch.bind(rogue), document)
      renders.push({
        key  : 'custom-bar-shaft-text-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
      stencils.push({
        key  : 'custom-bar-shaft-text-stencil',
        path : stencil!.outerHTML,
      })
      if (props.debug) {
        canvasRef.value?.appendChild(stencil!)
      }
    } else if (options.shaftImageLeft.val || options.shaftImageRight.val) {
      const shaftImageEl = document.getElementsByClassName('shaft-multi-image')[0].getElementsByTagName('svg')[0]
      const canvas = await createCanvas(shaftImageEl, gallery.value[3].link)
      const stencil = await getStencil(props.sku, zeusOptions, rogue.fetch.bind(rogue), document)
      renders.push({
        key  : 'custom-bar-shaft-image-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
      stencils.push({
        key  : 'custom-bar-shaft-image-stencil',
        path : stencil!.outerHTML,
      })
      if (options.shaftImageLeft.val) {
        uploads.push({
          key  : 'custom-bar-shaft-image-left',
          path : options.shaftImageLeftOriginal.val!,
        })
      }
      if (options.shaftImageRight.val) {
        uploads.push({
          key  : 'custom-bar-shaft-image-right',
          path : options.shaftImageRightOriginal.val!,
        })
      }
      if (props.debug) {
        canvasRef.value?.appendChild(stencil!)
      }
    }

    if (options.collarTextTop.val || options.collarTextBottom.val) {
      const collarText = document.getElementsByClassName('collar-text')[0].getElementsByTagName('svg')[0]
      const collarTextClone = collarText.cloneNode(true) as SVGSVGElement
      collarTextClone.setAttribute('style', '')
      const masks = collarTextClone.getElementsByTagName('mask')
      for (let i = 0; i < masks.length; i += 1) {
        masks[i].remove()
      }
      const canvas = await createCanvas(collarTextClone, gallery.value[4].link)
      collarTextClone.setAttribute('viewBox', '380 30 840 840')
      collarTextClone.removeAttribute('width')
      collarTextClone.removeAttribute('height')
      collarTextClone.getElementsByTagName('circle')[0].setAttribute('style', '')
      collarTextClone.getElementsByTagName('text')[1].removeAttribute('mask')
      renders.push({
        key  : 'custom-bar-collar-text-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
      stencils.push({
        key  : 'custom-bar-collar-text-stencil',
        path : collarTextClone.outerHTML,
      })
    }
    if (renders.length === 0) {
      const canvas = await createCanvas('', gallery.value[0].link)
      renders.push({
        key  : 'custom-bar-shaft-text-render',
        path : canvas!.toDataURL('img/jpeg', 0.8),
      })
    }

    const sideCollarTextSVG = document.getElementsByClassName('collar-text')[0].getElementsByTagName('svg')[0]
    const sideCollarCanvas = await createCanvas(sideCollarTextSVG, gallery.value[1].link)
    renders.push({
      key  : 'custom-bar-side-collar-render',
      path : sideCollarCanvas!.toDataURL('img/jpeg', 0.8),
    })
    const fullBarCollarTextSVG = document.getElementsByClassName('collar-text')[1].getElementsByTagName('svg')[0]
    const fullBarCanvas = await createCanvas(fullBarCollarTextSVG, gallery.value[2].link)
    renders.push({
      key  : 'custom-bar-full-bar-render',
      path : fullBarCanvas!.toDataURL('img/jpeg', 0.8),
    })
    const customizations: { key: string, type: string, value?: string | null }[] = Object.entries(options).map(([key, option]) => {
      let value = option.val
      if ((!options.shaftText.val && !options.shaftTextLeft.val && !options.shaftTextRight.val) && (key === 'shaftFont')) {
        value = null
      }
      if ((!options.shaftText.val
        && !options.shaftImage.val
        && !options.shaftTextLeft.val
        && !options.shaftTextRight.val
        && !options.shaftImageLeft.val
        && !options.shaftImageRight.val)
        && (key === 'shaftColor')) {
        value = null
      }
      if ((!options.collarTextTop.val && !options.collarTextBottom.val) && (key === 'collarFont' || key === 'collarColor')) {
        value = null
      }

      if (['shaftImageOriginal', 'shaftImageLeftOriginal', 'shaftImageRightOriginal'].includes(key)) {
        value = null
      }

      return {
        key,
        type: key === 'bushing' ? 'color' : option.type,
        value,
      }
    })

    const selectedChild = products.value[props.buyRequest.children!.find(c => c.qty > 0)!.productId]
    if (selectedChild) {
      customizations.push({
        key   : 'shaft',
        type  : 'color',
        value : selectedChild.attributes.color,
      })
    }
    if (props.debug) {
      return false
    }

    const recipeData = await rogue.fetch<Pick<RecipeResponse, 'recipeId'>>('/svc_zeus/recipes', 'post', {
      sku       : meta.sku,
      productId : simple.value.productId,
      price     : computePriceSync({ ...props.buyRequest, qty: 1 }, rogue.pinia!),
      customizations,
      renders,
      stencils,
      uploads,
    })

    meta.nonFluidCustomization = true
    meta.recipeId = recipeData.recipeId

    props.buyRequest.metadata = meta as BuyRequest['metadata']

    return true
  } catch (e) {
    rogue.log.error(e)

    return false
  }
}

async function loadRecipe() {
  if (!route.query.rid) {
    return
  }

  const recipeData = await rogue.fetch<RecipeResponse>(`/svc_zeus/recipes/${route.query.rid}`)

  if (!recipeData) {
    return
  }

  if (recipeData.sku?.indexOf('-CST') < 0) {
    // this is an NFL recipe
    const nflUrls: Record<string, string> = {
      RA2894 : '/rogue-bella-bar-nfl-edition?sku=',
      RA2889 : '/rogue-ohio-bar-nfl-edition?sku=',
      RA2895 : '/rogue-ohio-power-bar-nfl-edition?sku=',
    }

    const url = nflUrls[(recipeData.sku.split('-') || [])[0]]

    if (url) {
      router.replace(`${url}${recipeData.sku}`)

      return
    }
  }

  recipeData.customizations.forEach(option => {
    if (options[option.key]) {
      let value = option.value
      if ((option.key.indexOf('Font') > -1) && (option.value === null)) {
        value = 'arvo'
      }
      options[option.key].val = value
    }
  })

  // If this recipe is an image based recipe, select the Image tab
  let hasImage = Boolean(options.shaftImage.val?.trim())

  if (props.sku === 'CUSTOMOHIOPOWER_NEW') {
    // Power bar has a left and right
    hasImage = Boolean(options.shaftImageLeft.val || options.shaftImageRight.val)
  }

  if (hasImage) {
    tab.value = tabs.value[1]
  } else {
    tab.value = tabs.value[0]
  }

  props.buyRequest.children![0].productId = recipeData.productId
}

function selectImage(upload: string, original: string) {
  options.shaftImage.val = upload
  options.shaftImageOriginal.val = original
  selectedImg.value = 3
}

function selectLeftImage(upload: string, original: string) {
  options.shaftImageLeft.val = upload
  options.shaftImageLeftOriginal.val = original
  selectedImg.value = 3
}

function selectRightImage(upload: string, original: string) {
  options.shaftImageRight.val = upload
  options.shaftImageRightOriginal.val = original
  selectedImg.value = 3
}

watch(() => route.query.rid, () => {
  loadRecipe()
})

watch(tab, () => {
  update()
})

watch(options, () => {
  nextTick(() => {
    update()
  })
}, { deep: true })

watch(() => simple.value.productId, () => {
  nextTick(() => {
    validateColors()
    updateGallery()
  })
})

onServerPrefetch(async () => {
  await loadProducts()
  updateGallery()
})

onMounted(async () => {
  if (route.query?.rid) {
    const nflRecipeUrl = nflRecipeMap[route.query.rid as string]

    if (nflRecipeUrl) {
      router.replace(nflRecipeUrl)
    }
  }

  await loadProducts()
  await loadRecipe()
  handleScroll()
  updateGallery()
})

onUnmounted(() => {
  if (onScroll) {
    window.document.removeEventListener('scroll', onScroll)
    onScroll = null
  }
})
</script>
<style lang="scss" scoped>
//.transformed-collar {
//  transform: scale(0.81) translateX(-5%) translateY(-2%) rotateX(-34deg) rotateY(40deg) skew(0deg, -3deg)
//}
.canvas {
  width: 746px;
  height: 420px;
  canvas {
    width: 746px;
    height: 420px;
  }
}
.buy-btn {
  margin-top: $space-m;
}

.accordion-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-right: $space-l;

  .title {
    text-transform: uppercase;
  }
}
.disclaimer {
  margin-bottom: $size-s;
  display: block;
  font-size: 12px;
  line-height: 18px;
  flex-direction: column;
  align-items: flex-start;
  .terms {
    display: flex;
    align-items: center;
    margin-top: $size-xxs;
  }
}
.drop-area {
  margin-bottom: $size-s;
}
.img-choice {
  margin-top: $size-xs;
}
.terms {
  margin-top: $size-xs;
  font-size: $size-xs;
}
.font-choice :deep() {
  .swatch[data-value="arvo"]{
    font-family: 'Arvo', serif;
    font-weight: 700;
  }
  .swatch[data-value="arimo"]{
    font-family: 'Arimo', sans-serif;
    font-weight: 700;
  }
  .swatch[data-value="montserrat"]{
    font-family: 'Montserrat', sans-serif;
    font-weight: 800;
  }
}

</style>
<style lang="scss">
.custom-bar {
  .swatch[data-value='matte_black'] {
    display:none !important;
  }
  @include mobile {
    .sticky {
      position: sticky;
      top: 0;
      z-index: 2;
      background: #f8f8f8;
    }
  }
}
</style>
